<template>
    <nav class="fixed top-0 left-0 right-0 bg-white shadow-sm z-50">
        <div class="max-w-7xl mx-auto px-4 h-16 flex items-center">
        <img src="https://sx-official.oss-cn-shanghai.aliyuncs.com/logo1.png" alt="疏心小站" class="logo-h">
        <div class="flex-1 flex items-center justify-end space-x-6">
        <a href="#" class="text-gray-600 hover:text-blue-500">首页</a>
        <a href="#services" class="text-gray-600 hover:text-blue-500">服务项目</a>
        <a href="#team" class="text-gray-600 hover:text-blue-500">关于我们</a>
        <a href="#" class="text-gray-600 hover:text-blue-500">加入我们</a>
        <!--<button class="btn btn-primary !rounded-button whitespace-nowrap ml-6">立即咨询</button>
        <button class="btn btn-default !rounded-button whitespace-nowrap">登录/注册</button>-->
        </div>
        </div>
    </nav>
</template>

<script>
export default {
    name: 'MainNavbar'
}
</script>
<style scoped>
.logo-h{
    height: 3rem;
}
</style>